import {Button, Col, Form, Modal, Row, Spinner} from 'react-bootstrap'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useMutation} from '@apollo/client'
import {CREATE_USER} from '../../../graphql/mutations/userMutations'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {IResCreateUser} from '../../../graphql/types/usersTypes'

interface IModal {
  isOpen: boolean
  onClose: () => void
  refetch: () => void
}

const validationSchema = Yup.object({
  firstName: Yup.string().required('Nombres es requerido'),
  lastName: Yup.string().required('Apellidos es requerido'),
  email: Yup.string()
    .email('Correo electrónico inválido')
    .required('Correo electrónico es requerido'),
  password: Yup.string()
    .min(8, 'La contraseña debe tener al menos 8 caracteres')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&-]{8,}$/,
      'La contraseña debe contener al menos una letra y un número'
    )
    .required('Contraseña es requerida'),
  passwordConfirm: Yup.string()
    .oneOf([Yup.ref('password')], 'Las contraseñas no coinciden')
    .required('Obligatorio'),
})

export const ModalAddUser: React.FC<IModal> = ({isOpen, onClose, refetch}) => {
  const [gqlCreate, {data, loading, error}] = useMutation<IResCreateUser>(CREATE_USER)

  const [isShowPass, setIsShowPass] = useState(false)
  const [isShowConfirmPass, setIsShowConfirmPass] = useState(false)

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      passwordConfirm: '',
    },
    validationSchema,
    onSubmit: (values) => {
      gqlCreate({
        variables: {
          input: values,
        },
      })
    },
  })

  useEffect(() => {
    if (error) toast.error(`Error: ${error}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    console.log('data', data)
    if (data.userCreate.success) {
      toast.success('Usuario agregado correctamente')
      onClose()
      refetch()
    } else if (data.userCreate.errors) {
      console.log('enret')

      toast.error(`Error: ${data.userCreate.errors.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <Modal show={isOpen} onHide={onClose} size='lg'>
      <Modal.Header closeButton>
        <Modal.Title>Registrar Usuario</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit} id='formId'>
          <Form.Group controlId='firstName'>
            <Form.Label>Nombres</Form.Label>
            <Form.Control
              type='text'
              name='firstName'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.firstName}
              isInvalid={Boolean(formik.touched.firstName && formik.errors.firstName)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.firstName}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mt-3' controlId='lastName'>
            <Form.Label>Apellidos</Form.Label>
            <Form.Control
              type='text'
              name='lastName'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.lastName}
              isInvalid={Boolean(formik.touched.lastName && formik.errors.lastName)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.lastName}</Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mt-3' controlId='email'>
            <Form.Label>Correo electrónico</Form.Label>
            <Form.Control
              type='email'
              name='email'
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.email}
              isInvalid={Boolean(formik.touched.email && formik.errors.email)}
            />
            <Form.Control.Feedback type='invalid'>{formik.errors.email}</Form.Control.Feedback>
          </Form.Group>
          <Row>
            <Col sm={12} md={6}>
              <Form.Group className='mt-3 position-relative' controlId='password'>
                <Form.Label>Contraseña</Form.Label>
                <Form.Control
                  type={isShowPass ? 'text' : 'password'}
                  name='password'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  isInvalid={Boolean(formik.touched.password && formik.errors.password)}
                />
                <button
                  style={{
                    position: 'absolute',
                    right: formik.touched.password && formik.errors.password ? '30px' : '5px',
                    top: formik.errors.password ? '34px' : '55%',
                  }}
                  type='button'
                  className='btn-reset'
                  onClick={() => setIsShowPass((p) => !p)}
                >
                  {isShowPass ? (
                    <i className='bi bi-eye-slash-fill fs-5 text-dark' />
                  ) : (
                    <i className='bi bi-eye-fill fs-5 text-dark' />
                  )}
                </button>
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.password}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col sm={12} md={6}>
              <Form.Group className='mt-3 position-relative' controlId='passwordConfirm'>
                <Form.Label>Confirmación de contraseña</Form.Label>
                <Form.Control
                  type={isShowConfirmPass ? 'text' : 'password'}
                  name='passwordConfirm'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.passwordConfirm}
                  isInvalid={Boolean(
                    formik.touched.passwordConfirm && formik.errors.passwordConfirm
                  )}
                />
                <button
                  style={{
                    position: 'absolute',
                    right:
                      formik.touched.passwordConfirm && formik.errors.passwordConfirm
                        ? '30px'
                        : '5px',
                    top: formik.errors.passwordConfirm ? '34px' : '55%',
                  }}
                  type='button'
                  className='btn-reset'
                  onClick={() => setIsShowConfirmPass((p) => !p)}
                >
                  {isShowConfirmPass ? (
                    <i className='bi bi-eye-slash-fill fs-5 text-dark' />
                  ) : (
                    <i className='bi bi-eye-fill fs-5 text-dark' />
                  )}
                </button>
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.passwordConfirm}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose} type='button'>
          Cancelar
        </Button>
        <Button form='formId' variant='primary' type='submit' disabled={loading}>
          {loading && <Spinner animation='border' size='sm' className='me-2' />}
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
